/**
 * TS014: first four visible PLP images eager + high fetch priority.
 * Klevu paints the grid after load and may set loading=lazy afterwards.
 * TS022 related products sit below the fold, so they stay lazy.
 */
(function () {
  var GRID = '[data-block-id="ku_landing_result_items"] .kuResults li.klevuProduct img.kuProdImg';
  var TILE = '.product-tile__image:not(.product-tile__image--alt)';

  function mark(img, loading, priority) {
    if (img.getAttribute('loading') !== loading) {
      img.setAttribute('loading', loading);
    }
    if (priority) {
      if (img.getAttribute('fetchpriority') !== priority) {
        img.setAttribute('fetchpriority', priority);
      }
      try {
        img.fetchPriority = priority;
      } catch (err) {
        /* older browsers */
      }
    }
  }

  function relax(img) {
    if (img.getAttribute('loading') !== 'lazy') {
      img.setAttribute('loading', 'lazy');
    }
    if (img.hasAttribute('fetchpriority')) {
      img.removeAttribute('fetchpriority');
    }
  }

  function prioritize() {
    var imgs = document.querySelectorAll(GRID);
    if (!imgs.length) imgs = document.querySelectorAll(TILE);
    var boosted = 0;
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].closest('[data-ts022-related], [data-ts022-recent]')) {
        relax(imgs[i]);
        continue;
      }
      if (boosted < 4) {
        mark(imgs[i], 'eager', 'high');
        boosted++;
      }
    }
  }

  window.__tsPrioritizePlpImages = prioritize;

  prioritize();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prioritize);
  }

  window.addEventListener('load', function () {
    prioritize();
    setTimeout(prioritize, 250);
    setTimeout(prioritize, 1000);
  });

  if (typeof MutationObserver === 'function') {
    var timer;
    var observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(prioritize, 50);
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['loading']
    });
  }
})();
